import loadable from "@loadable/component";

const NotFoundErrorPageRoute = loadable(() =>
  import(
    /* webpackPreload: true, webpackChunkName: "PAGE_NOT_FOUND" */ "./NotFoundErrorPage"
  )
);

export default NotFoundErrorPageRoute;
